import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PositiveListService from "src/modules/data-protection/apis/PositiveListService";
import { getPositiveListErrorKey } from "../helpers/apiError";
import { POSITIVE_LIST_QUERY_KEY } from "../helpers/measureList";
import { isSettableUsageStatus } from "../helpers/usage";

const useSetPositiveListUsage = ({ softwareId, t } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ measureId, status }) => {
            if (!isSettableUsageStatus(status)) {
                throw new Error("Usage status must be yes or no.");
            }

            const service = PositiveListService.getInstance();

            return await service.setUsage(measureId, { status });
        },
        onSuccess: () => {
            queryClient.invalidateQueries([POSITIVE_LIST_QUERY_KEY, softwareId]);
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            const errorKey = getPositiveListErrorKey(error);

            toast(
                t(errorKey || "An error occurred while updating usage."),
                {
                    type: "error",
                }
            );
        },
    });
};

export default useSetPositiveListUsage;
